import axios from 'axios';

import buildPaginationQueryOpts from '@/shared/sort/sorts';

import { IMap2d } from '@/shared/model/map-2-d.model';

const baseApiUrl = 'api/map-2-ds';
const baseMobileApiUrl = 'api/mobile/map-2-ds';

export default class Map2dService {
  public find(id: number): Promise<IMap2d> {
    return new Promise<IMap2d>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/${id}`)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public findByMobileApi(id: number, token: string): Promise<IMap2d> {
    return new Promise<IMap2d>((resolve, reject) => {
      axios
        .get(`${baseMobileApiUrl}/${id}?accessToken=${token}`)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public retrieve(paginationQuery?: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(baseApiUrl + `?${buildPaginationQueryOpts(paginationQuery)}`)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public delete(id: number): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .delete(`${baseApiUrl}/${id}`)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public create(entity: IMap2d): Promise<IMap2d> {
    return new Promise<IMap2d>((resolve, reject) => {
      axios
        .post(`${baseApiUrl}`, entity)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public join(ids: Array<number>): Promise<IMap2d> {
    return new Promise<IMap2d>((resolve, reject) => {
      axios
        .post(`${baseApiUrl}/join`, ids)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public update(entity: IMap2d): Promise<IMap2d> {
    return new Promise<IMap2d>((resolve, reject) => {
      axios
        .put(`${baseApiUrl}/${entity.id}`, entity)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public partialUpdate(entity: IMap2d): Promise<IMap2d> {
    return new Promise<IMap2d>((resolve, reject) => {
      axios
        .patch(`${baseApiUrl}/${entity.id}`, entity)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public filter(paginationQuery?: any, filter?: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(baseApiUrl + `/filter?${buildPaginationQueryOpts(paginationQuery)}`, filter)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public tile(id?: number, x?: number, y?: number, z?: number) {
    return new Promise<IMap2d>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/${id}/tile?x=${x}&y=${y}&z=${z}`)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public tileUrl(id: number) {
    return `${baseApiUrl}/${id}/tile?x={x}&y={y}&z={z}`;
  }

  public tileUrlMobile(id: number, token: string) {
    return `${baseMobileApiUrl}/${id}/tile?accessToken=${token}&x={x}&y={y}&z={z}`;
  }
  public dxfTileUrl(id: number) {
    return `${baseApiUrl}/${id}/dxf-tiles?x={x}&y={y}&z={z}`;
  }
  public dxfTileUrlMobile(id: number, token: string) {
    return `${baseMobileApiUrl}/${id}/dxf-tiles?accessToken=${token}&x={x}&y={y}&z={z}`;
  }
}
